import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'linaria';
/**
 * Defaults to aligning child items to the right. Will likely contain button actions
 * but can be configured per instance
 */

const modalFooterStyles = "m11mcrga";
export const ModalFooter = ({
  children,
  hasBorder,
  isSticky,
  className
}) => {
  return <div className={cx(modalFooterStyles, hasBorder && 'bordered', isSticky && 'sticky', className)}>
      {children}
    </div>;
};
ModalFooter.propTypes = {
  hasBorder: PropTypes.bool,
  isSticky: PropTypes.bool
};
ModalFooter.defaultProps = {
  hasBorder: true,
  isSticky: true
};
export default ModalFooter;

require("./modal-footer.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./modal-footer.js");